<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Avaliações do estágio</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="filter.nome" />
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="nomeTraduzido">Nome Traduzido</label>
                                    <input type="text" class="form-control" name="nomeTraduzido" placeholder="Nome Traduzido" v-model="filter.nomeTraduzido" />
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="unidade">Unidade</label>
                                    <input type="text" class="form-control" name="unidade" placeholder="Unidade" v-model="filter.unidade" />
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="tipoAvaliacaoId">Tipo da Avaliação</label>
                                    <select v-select="{ dataitem: 'TipoAvaliacao', default: 'Selecione' }" v-model="filter.tipoAvaliacaoId" class="form-control" name="tipoAvaliacaoId"></select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label>Lança nota de 0 a 10</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ignoraPontuacaoPadrao" v-model="filter.ignoraPontuacaoPadrao" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ignoraPontuacaoPadrao" v-model="filter.ignoraPontuacaoPadrao" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ignoraPontuacaoPadrao" v-model="filter.ignoraPontuacaoPadrao" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label>Meio de Curso</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="meioCurso" v-model="filter.meioCurso" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="meioCurso" v-model="filter.meioCurso" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="meioCurso" v-model="filter.meioCurso" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Excluído</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="excluido" v-model="filter.excluido" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="excluido" v-model="filter.excluido" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="excluido" v-model="filter.excluido" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <section class="col-sm-12">
                                <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                                <button type="button" class="btn-large-40 btn-success uppercase pull-right" @click="openCreate()">
                                    Criar
                                </button>
                            </section>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Ordem<i @click="executeOrderBy('ordem')" class="fa fa-sort"></i></th>
                                    <th>Nome<i @click="executeOrderBy('nome')" class="fa fa-sort"></i></th>
                                    <th>Nome Traduzido<i @click="executeOrderBy('nomeTraduzido')" class="fa fa-sort"></i></th>
                                    <th>Unidade<i @click="executeOrderBy('unidade')" class="fa fa-sort"></i></th>
                                    <th>Pontuação<i @click="executeOrderBy('pontuacao')" class="fa fa-sort"></i></th>
                                    <th>Meio de Curso<i @click="executeOrderBy('meiocurso')" class="fa fa-sort"></i></th>
                                    <th>Excluído<i @click="executeOrderBy('excluido')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.ordem }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.nomeTraduzido }}</td>
                                    <td>{{ item.unidade }}</td>
                                    <td>{{ item.pontuacao }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.meioCurso, 'badge-danger': !item.meioCurso }">{{item.meioCurso ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.excluido, 'badge-danger': !item.excluido }">{{item.excluido ? 'Sim' : 'Não'}}</span></td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ estagioAvaliacaoId: item.estagioAvaliacaoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ estagioAvaliacaoId: item.estagioAvaliacaoId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" :estagio-id="estagioId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="estagioAvaliacaoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'estagioavaliacao',
        mixins: [base],
        props: { estagioId: Number },
        components: { formCreate, formEdit },
        data() {
            return {
                resources: {
                    filter: 'estagioavaliacao',
                    remove: 'estagioavaliacao'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    tipoAvaliacaoId: ""
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.estagioAvaliacaoId = model.estagioAvaliacaoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.estagioId = this.estagioId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {

            this.executeFilter();
        }

    };
</script>